import api from '@/api/API';
import { AccountSettings } from '@/types';

export function setAutoRenew(accountId: string, autoRenew: boolean): Promise<void> {
  return api
    .put(`accounts/${accountId}/auto-renew`, { autoRenew })
    .then();
}

export function update(accountSettings: AccountSettings): Promise<void> {
  return api
    .put(`account-settings/${accountSettings.id}`, {
      apiKey: accountSettings.apiKey,
      autoReportGenerate: accountSettings.autoReportGenerate,
      autoRenewal: accountSettings.autoRenewal,
      fetchPeriod: accountSettings.fetchPeriod,
      notifyClientReportGenerated: accountSettings.notifyClientReportGenerated,
      timezone: accountSettings.timezoneOffset,
      customFields: accountSettings.customFields,
    }).then();
}
